<div class="sidenav-body-wrapper" fxLayout="row" fxLayoutAlign="start">
    <!-- left nav -->
      <div *ngIf="showSidebar" class="left-nav-wrapper" [fxFlex]="isMenuCollapsed ? '4' : '15'" [class.collapsed]="isMenuCollapsed" style="background: #dcdcdc;">
        <app-left-menu [isCollapsed]="isMenuCollapsed" (toggleCollapse)="toggleMenu()" (refreshNotification)="refreshNotification($event)"></app-left-menu>
    </div>

    <ngx-simplebar class="body-wrapper" [fxFlex]="showSidebar ? (isMenuCollapsed ? '96' : '85') : '100'">
        <app-header *ngIf="showGlobalHeader" class="header-wrapper border-box-shadow" (toggleSidebar)="toggleMenu()"></app-header>
        <div class="router-wrapepr" [class.no-header]="!showGlobalHeader" style="color:red">
            <router-outlet></router-outlet>
            <app-footer></app-footer>
        </div>
    </ngx-simplebar>
</div>
